const Form062TC = {
    stepName: {
        statement: "重要提示",
        basicInfor: "學校基本資料",
        partA: "商業活動的資料",
        partB: "其他詳細資料及聲明",
        confirmation: "確認",
    },
    errorMsg: {
        date: {
            afterThisDate: "請在 {{targetDate}} 之後選擇日期",
        },
        float: {
            rule: "該字段必須是'數字'類型，最大小數點位數：2",
        },
    },
    businessTypes: {
        "Exercise books": "習作簿",
        "Stationery and school accessories": "文具及其他用品",
        Textbooks: "課本",
        "School uniforms, badges and ties": "校服、校章及領帶",
        "Physical education kits": "體育用品",
        "Lunch boxes": "飯盒",
        "School bus service": "校巴服務",
        "School Tuckshop": "食物部",
        Newspaper: "報紙",
        Others: "其他",
    },
    itemTypes: {
        "Exercise books": "(1)",
        "Stationery and school accessories": "(2)",
        Textbooks: "(3)",
        "School uniforms, badges and ties": "(4)",
        "Physical education kits": "(5)",
        "Lunch boxes": "(6)",
        "School bus service": "(7)",
        "School Tuckshop": "(8)",
        Newspaper: "(9)",
        Others: "(10)",
    },
    CSDOTypes: {
        "CW&S": "中西及南區",
        HKE: "東區",
        "WCH&I": "灣仔及離島區",
        KC: "九龍城區",
        KT: "觀塘區",
        SK: "西貢區",
        SSP: "深水埗區",
        WTS: "黃大仙區",
        YTM: "油尖旺區",
        N: "北區",
        ST: "沙田區",
        TP: "大埔區",
        "TW&KwT": "荃灣及葵青區",
        TM: "屯門區",
        YL: "元朗區",
    },
    label: {
        committees: "申請批准經營商業活動",
        business: "業務類別及供應商／承辦商的姓名／名稱",
        otherDetails: "其他詳細資料",
        schoolName: "學校名稱",
        schoolAddress: "學校地址",
        CSDO: "總學校發展主任",
        effectDate: "本校現申請由下列日期起經營/進行以下業務或商業活動/安排",
        businessType: "業務／商業活動／安排類別",
        supplierName: "供應商／承辦商姓名／名稱",

        approvalSubHeading: "校董會批准",
        referenceNo: "校董會批准檔案編號",
        approvalDate: "校董會批准日期",
        // referenceNo: "校內檔案編號",
        // approvalDate: "批准日期",

        // itemNo: "項目編號",
        itemNo: "業務／商業活動／安排類別",
        rental: "租金",
        utilitiesCharges: "雜費(例如：水、電、煤氣)",
        commencementDate: "生效日期",
        terminationDate: "終止日期",
        documents: "證明文件(如有)",
        operationValue: "理由",
        HKD: "港幣",
        specific: "請註明",
        statement: "聲明（請在適當空格內加上「√」號）",
        statementTwo: "聲明",
        certify: "本人已閱讀及明白上述條款及細則。",
        rentalNote: "請視乎何者合適，註明按月或按年繳付的金額",
        utilitiesNote:
            "請註明由供應商／承辦商按實際用量或按月／年以定額形式繳付／退還的金額",
        itemNoNote: "請採用與以上（A）部相同的項目編號。",
        agreement: "與供應商／承辦商簽訂的經營合約",
        basicInfo: "學校基本資料",
    },
    statementValue: {
        statement1:
            "本人謹此確認，就經營／進行上述業務或商業活動／安排的申請，本校會遵照教育局現行有關「學校的商業活動」的通告內所載的規定，並確保以公開、公平及透明的原則經營商業活動，並特此確認，所有由上述活動所得的利潤或淨收入將運用於能夠使<u>本校學生直接受益</u>的用途上。",
        statement2:
            "就經營／進行上述業務或商業活動／安排的申請，本校的安排將有別於教育局現行有關「學校的商業活動」的通告內所載的規定，詳情及原因如下－",
    },
    importantNotes: {
        note1: "請提交電子表格或紙質表格，請注意，如果提交了重複的申請，處理過程可能會受影響。",
        note2: "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向有關高級學校發展主任提出。",
    },
    note: {
        note: "進入此網站前請先仔細閱讀以下條款及細則。",
        noteList: [
            {
                text: "此申請批准經營商業活動的網上表格只適用於由校董會管理的學校。",
            },
            {
                text: "學校在填寫此表格前請先參閱教育局現行有關學校的商業活動的通告。",
            },
            {
                text: "校監須使用「智方便+」數碼簽署作核准。",
            },
            {
                text: "請以電子表格或紙本表格提交申請。如重複遞交申請，申請進度可能會受影響。",
            },
        ],
    },
};
export default Form062TC;
